import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import pageConfig from '../../config/page.config';
import { MHero } from '../../components/molecules';
import { OCategoriePreview, ODynamicStory, OHouseHoldStory } from '../../components/organisme';
import { asbestplaat, asbestWarning, asbestKwarts } from '../../assets/images/images/';
import { changeHead } from '../../redux/head/headActions';

class AsbestPage extends React.Component {
	componentDidMount() {
		this.props.changeHeadFunc({
			title: this.props.intl.formatMessage({ id: pageConfig.asbest.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.asbest.description }),
			showSocialMedia: true,
		});
	}

	render() {
		return (
			<section>
				<MHero
					img={asbestplaat}
					currentPage="BREAD_CRUMB.ASBEST"
					className="a-hero--bottom-align t-gap--bottom-xl"
				/>
				<article className="section-md layout-body--fill-with-hero">
					<ODynamicStory
						img={asbestWarning}
						description="ASBEST.TEKST_1"
						className="t-gap--bottom-xx"
					/>
					<OCategoriePreview
						items={pageConfig.asbest.productPreviewList}
						className="t-gap--bottom-xx"
					/>
					<OHouseHoldStory
						img={asbestplaat}
						direction="right"
						title="ASBEST.TEKST_2.TITLE"
						description="ASBEST.TEKST_2.DESCRIPTION"
						className="t-gap--bottom-xx"
					/>
					<ODynamicStory
						img={asbestKwarts}
						description="ASBEST.TEKST_3"
						className="t-gap--bottom-xl"
					/>
				</article>
			</section>
		);
	}
}

AsbestPage.propTypes = {
	changeHeadFunc: PropTypes.func.isRequired,
};

export default withRouter(connect(undefined, {
	changeHeadFunc: changeHead,
})(injectIntl(AsbestPage)));



// WEBPACK FOOTER //
// ./src/pages/about-us/asbest.page.js